import { motion } from "framer-motion";
import { skillGroups } from "../../data/content";
import { SectionHeading, staggerContainer, staggerItem } from "./Reveal";

export const Skills = () => (
  <section
    id="skills"
    data-testid="skills-section"
    className="relative max-w-6xl mx-auto px-6 md:px-12 py-24 md:py-32"
  >
    <SectionHeading
      index="04"
      overline="Capabilities"
      title="What I actually build."
      description="Grouped by what it does for a product — not a wall of logos. Each area reflects systems I've shipped and maintained in production."
    />

    <motion.div
      variants={staggerContainer}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, margin: "-60px" }}
      className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6"
    >
      {skillGroups.map((g) => (
        <motion.div
          key={g.title}
          variants={staggerItem}
          data-testid={`skill-group-${g.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
          className="group rounded-3xl border border-[var(--border-subtle)] bg-surface p-7 md:p-8 transition-all duration-300 hover:border-[var(--border-strong)] hover:bg-surface-elevated"
        >
          <h3 className="font-heading font-bold text-lg md:text-xl tracking-tight text-primary-c">
            {g.title}
          </h3>
          <p className="mt-3 text-sm md:text-[15px] text-secondary-c leading-relaxed">
            {g.description}
          </p>
          <div className="mt-5 flex flex-wrap gap-2">
            {g.items.map((it) => (
              <span
                key={it}
                className="font-mono-tech text-[11px] tracking-wide bg-white/[0.04] border border-white/10 text-secondary-c rounded-full px-2.5 py-1"
              >
                {it}
              </span>
            ))}
          </div>
        </motion.div>
      ))}
    </motion.div>
  </section>
);
